import { useState } from "react";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardActionArea from "@mui/material/CardActionArea";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import SpeedIcon from "@mui/icons-material/Speed";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(2),
  color: (theme.vars ?? theme).palette.text.secondary,
  ...theme.applyStyles("dark", {
    backgroundColor: "#1A2027",
  }),
}));

const Services = () => {
  const [selectedCard, setSelectedCard] = useState(0);

  const cards = [
    {
      id: 1,
      title: "Veloz",
      description: "30 Megas",
      amount: "$ 350.00",
      term: "Al mes",
      question: "Hola, quiero contratar el paquete: Veloz (30 MB).",
    },
    {
      id: 2,
      title: "Avanzado",
      description: "50 Megas",
      amount: "$ 450.00",
      term: "Al mes",
      question: "Hola, quiero contratar el paquete: Avanzado (50 MB).",
    },
    {
      id: 3,
      title: "Premium",
      description: "70 Megas",
      amount: "$ 550.00",
      term: "Al mes",
      question: "Hola, quiero contratar el paquete: Premium (70 MB).",
    },
  ];

  return (
    <Box sx={{ flexGrow: 1, width: "100%", py: 4 }}>
      <Item elevation={0}>
        <Box sx={{ mb: 4, textAlign: "center" }}>
          <Typography variant="h4" component="h2" sx={{ fontFamily:'fantasy',fontSize: { xs: '1.4rem', md: '1.8rem' },fontWeight: "bold", color: "#0d47a1", mb: 1 }}>
            Paquetes de Internet REDCOMP
          </Typography>
          <Typography variant="subtitle1" color="text.secondary">
            Selecciona el plan que mejor se adapte a tus necesidades
          </Typography>
        </Box>

        {/* Grid de Tarjetas */}
        <Box
          sx={{
            width: "100%",
            display: "grid",
            gridTemplateColumns: {
              xs: "repeat(auto-fill, minmax(min(100%, 100%), 1fr))",
              md: "repeat(auto-fill, minmax(min(31%, 100%), 1fr))",
            },
            gap: 3,
            justifyContent: "center",

          }}
        >
          {cards.map((card, index) => {
            const isSelected = selectedCard === index;

            return (
              <Card
                key={card.id}
                sx={{
                  width: "100%",
                  borderRadius: 3,
                  boxShadow: isSelected ? 6 : 2,
                  border: isSelected ? "2px solid #1976d2" : "1px solid #e0e0e0",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    boxShadow: 6,
                  },
                }}
              >
                <CardActionArea
                  onClick={() => setSelectedCard(index)}
                  sx={{
                    height: "80%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    p: 2,
                    backgroundColor: isSelected ? "rgba(25, 118, 210, 0.04)" : "transparent",
                  }}
                >
                  <CardContent sx={{ width: "100%", textAlign: "center", p: 1 }}>
                    {/* Título del Paquete */}
                    <Typography
                      variant="h6"
                      component="div"
                      sx={{
                        fontWeight: "bold",
                        color: "#333",
                        mb: 1,
                        fontFamily:'fantasy',
                        fontSize: { xs: '1.9rem', md: '1.9rem' },
                      }}
                    >
                      {card.title}
                    </Typography>

                    {/* Velocidad */}
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1, my: 1 }}>
                      <SpeedIcon color="primary" />
                      <Typography
                        variant="h4"
                        sx={{
                          fontWeight: "bold",
                          color: "#1976d2",  
                        }}
                      >
                        {card.description}
                      </Typography>
                    </Box>

                    {/* Precio y Término */}
                    <Box sx={{ my: 2 }}>
                      <Typography
                        variant="h4"
                        sx={{
                          fontWeight: "bold",
                          color: "#2e7d32",
                        }}
                      >
                        {card.amount}
                      </Typography>
                      <Typography variant="caption" color="text.secondary" sx={{fontSize: { xs: '1.2rem', md: '1.1rem' }}}>
                        {card.term}
                      </Typography>
                    </Box>

                    {/* Botón de Contratación directo a WhatsApp */}
                    <Button
                      sx={{
                        width: "100%",
                        mt: 2,
                        py: 1.2,
                        fontWeight: "bold",
                        borderRadius: 2,
                        textTransform: "none",
                        fontSize: "1rem",
                      }}
                      variant={isSelected ? "contained" : "outlined"}
                      color="primary"
                      startIcon={<WhatsAppIcon />}
                      href={`https://wa.me/527447505274?text=${encodeURIComponent(card.question)}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={(e) => e.stopPropagation()} // Evita activar el evento onClick de CardActionArea
                    >
                      Contratar
                    </Button>
                  </CardContent>
                </CardActionArea>
              </Card>
            );
          })}
        </Box>
      </Item>
    </Box>
  );
};

export default Services;